<template>
  <div class="regional-prices-edit-field">
    <!--    <v-label class="regional-prices-edit-field__label v-label&#45;&#45;active" >
      <span>Цены для регионов</span>
    </v-label>-->
    <label class="regional-prices-edit-field__label">
      <span>Цены для регионов</span>
    </label>
    <v-row
      class="regional-prices-edit-field__row"
      v-for="(item, key) in rows"
      :key="`rp-${key}-${getHash(item)}`"
    >
      <v-col cols="7">
        <v-select
          v-model="rows[key].regionId"
          :items="regions"
          label="Регион"
          item-text="name"
          item-value="id"
          outlined
          required
          :loading="loading"
          :disabled="loading"
          :rules="rules.requiredNumber"
          @input="syncValue"
        />
      </v-col>

      <v-col cols="4">
        <v-text-field
          outlined
          required
          label="Цена"
          v-model="rows[key].priceRub"
          :loading="loading"
          :disabled="disabled"
          :rules="rules.requiredNumber"
          @input="syncValue"
        />
      </v-col>
      <v-col cols="1">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="accent"
              elevation="1"
              icon
              small
              class="mb-2 mt-3"
              v-bind="attrs"
              v-on="on"
              @click="deleteItem(key)"
            >
              <!-- eslint-disable-next-line -->
<!--              <v-icon small>mdi-delete</v-icon>-->
              <font-awesome-icon icon="times"/>
            </v-btn>
          </template>
          <span>Удалить</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row class="regional-prices-edit-field__add">
      <v-col cols="3">
        <v-btn
          type="button"
          :loading="loading"
          :disabled="disabled"
          @click.s.stop="addEmptyItem"
          block
        >
          Добавить
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import md5 from 'md5'
  import { mapGetters } from 'vuex'
  // import TextField from '@/components/ui/crud/fields/TextField'
  import rules from '@/mixins/rules'

  export default {
    name: 'RegionalPricesField',
    components: { },
    mixins: [rules],
    data () {
      return {
        rows: [],
      }
    },
    props: {
      value: {
        type: Array,
        default: () => [],
      },
      loading: Boolean,
      disabled: Boolean,
    },
    computed: {
      ...mapGetters({
        regions: 'regions/getRegions',
      }),
    },
    watch: {
      value (newValue) {
        this.rows = newValue
      },
    },
    methods: {
      getHash (item) {
        return md5(item)
      },
      addEmptyItem () {
        this.rows.push({
          regionId: null,
          priceRub: null,
        })
      },
      deleteItem (key) {
        console.log(key)
        this.rows = this.rows.splice(key, 1)
      },
      setRowRegion (key, value) {
        console.log(key, value)
        // this.rows[key]. = value
        // this.rows = [...this.rows]
      },

      syncValue () {
        this.$emit('input', this.rows)
      },
    },
    created () {
      if (!this.regions || this.regions.length === 0) {
        this.$store.dispatch('regions/fetchRegions')
      }
    },
  }
</script>

<style lang="less" scoped>
.regional-prices-edit-field {
  padding: 30px;
  border-radius: 4px;
  border: 1px solid rgba(0,0,0,0.38);
  position: relative;
  margin-bottom: 50px;

  &__label {
    position: absolute;
    top: 11px;
    left: -12px;
    background: white;
    padding: 0 5px;
    transform: translateY(-24px) scale(0.75);
    color: #999999;
    font-size: 16px;
  }
  &__row {
    padding-top: 5px;
    padding-bottom: 5px;

    ::v-deep {
      .col {
        padding-bottom: 0;
        padding-top: 0;
      }
    }
  }
}
</style>
